/**
 * Builds backend URLs for fetch().
 *
 * Production (Hestia/Nginx with `rewrite ^/api(/.*)$ $1 break`):
 *   REACT_APP_API_URL=https://miskosas.com/api
 *   apiUrl('/api/blog/posts') → https://miskosas.com/api/api/blog/posts
 *   Nginx forwards to Express as GET /api/blog/posts
 *
 * Local dev (empty base or package.json proxy):
 *   apiUrl('/api/blog/posts') → /api/blog/posts
 *
 * Direct backend (REACT_APP_API_URL=http://localhost:3020):
 *   apiUrl('/api/blog/posts') → http://localhost:3020/api/blog/posts
 */

export function getApiBase() {
  return (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
}

/**
 * @param {string} path - e.g. /api/config, /auth/me
 * @returns {string}
 */
export function apiUrl(path) {
  const base = getApiBase();
  const p = path.startsWith('/') ? path : `/${path}`;
  if (!base) return p;
  return `${base}${p}`;
}

/** Auth routes live at /auth/* on Express; use the /api/ proxy prefix in production. */
export function authUrl(path) {
  return apiUrl(path.startsWith('/') ? path : `/${path}`);
}

/** Blog images and uploads served by the backend. */
export function assetUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return apiUrl(path.startsWith('/') ? path : `/${path}`);
}
